import { Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Component, EventEmitter, Output } from '@angular/core';
import { Table } from 'primeng/table';
import { ListBase } from 'src/app/components/core/_infrastructure/classes/listBase';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { FilterSearchingBaseViewModel } from 'src/app/components/core/_infrastructure/types/common';
import { proxiedPropertiesOf } from 'src/app/components/core/_infrastructure/types/utils';
import { AforoItemResultsViewModel, AforoItemViewModel } from '../aforos.types';

@Component({
    selector: 'app-aforo-list',
    templateUrl: './aforo-list.component.html',
})
export class AforoListComponent extends ListBase implements OnInit, OnChanges {
    @Input() result: AforoItemResultsViewModel;
    @Input() lastFilter: FilterSearchingBaseViewModel;
    @Input() readonly: boolean;
    @Output() search = new EventEmitter<FilterSearchingBaseViewModel>();
    @Output() edit = new EventEmitter<number | null>();
    @Output() delete = new EventEmitter<number | null>();

    @ViewChild('tableSearch') turboTable: Table;

    cols: any[] = [];
    title = 'Listado de Aforos';

    constructor(protected notificationService: NotificationService) {
        super(notificationService);
    }

    ngOnInit(): void {
        this.initCols();
        this.loading = false;
    }

    private initCols(): void {
        const aforoVM = proxiedPropertiesOf<AforoItemViewModel>();
        this.cols = [];

        this.cols = [
            ...this.cols,
            ...[
                { field: 'Link', header: '', reduce: true },
                { field: aforoVM.IdComunidadAutonomaDescripcion?.toString(), header: 'Comunidad Autónoma' },
                { field: aforoVM.IdProvinciaDescripcion?.toString(), header: 'Provincia' },
                { field: aforoVM.TitularRecinto?.toString(), header: 'Recinto' },
                { field: aforoVM.IdVariedadDescripcion?.toString(), header: 'Variedad' },
                { field: aforoVM.Descripcion, header: 'Descripción' },
                { field: aforoVM.Anyo?.toString(), header: 'Año' },
                { field: aforoVM.Mes, header: 'Mes' },
                { field: aforoVM.KgsProduccionEstimada?.toString(), header: 'Producción Estimada (kgs)' },
                { field: aforoVM.KgsProduccionReal?.toString(), header: 'Producción Real (kgs)' },
            ],
        ];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.result?.currentValue) {
            this.result = { ...changes.result.currentValue };
            this.loading = false;
            setTimeout(() => {
                if (this.turboTable) {
                    this.turboTable.sortOrder = this.lastFilter?.Asc;
                    this.turboTable.sortField = this.lastFilter?.OrderBy;
                    this.turboTable.first = this.lastFilter?.PageNumber * this.result.PageSize;
                }
            }, 100);
        }
    }

    onSearchLazy(event: any): void {
        if (!event.rows || event.sortField === 'Link') {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.loading = true;

        const f: FilterSearchingBaseViewModel = {
            PageNumber: pageNumber,
            Asc: event.sortOrder,
            OrderBy: event.sortField || '',
        };

        this.search.emit(f);
    }

    onEdit(item: AforoItemViewModel): void {
        this.edit.emit(item?.Id);
    }

    onDelete(item: AforoItemViewModel): void {
        this.delete.emit(item?.Id);
    }
}
